import { gql } from "@/api/utils.js"

export default [
	{
		type: "caseWhere",
		label: "Case",
		componentName: "SelectByCaseId",
		query: gql`
			query fetchCases {
				cases {
					list {
						id
						holder {
							name
						}
						component {
							name
						}
					}
				}
			}
		`
	},
	{
		type: "proposalWhere",
		label: "Proposal Number",
		componentName: "SelectByCaseId",
		query: gql`
			query fetchProposals($caseWhere: caseWhere) {
				cases(where: $caseWhere) {
					list {
						id
						proposals {
							id
							proposalNumber
						}
					}
				}
			}
		`
	},
	{
		type: "offerWhere",
		label: "Offer Number",
		componentName: "SelectByCaseId",
		query: gql`
			query fetchOffers($caseWhere: caseWhere, $proposalWhere: proposalWhere) {
				cases(where: $caseWhere) {
					list {
						id
						proposals(where: $proposalWhere) {
							id
							basket {
								id
								offerNumber
							}
						}
					}
				}
			}
		`
	},
	{
		type: "policyWhereInput",
		label: "Policy ID",
		componentName: "SelectByCaseId",
		query: gql`
			query fetchPolicies(
				$caseWhere: caseWhere
				$proposalWhere: proposalWhere
			) {
				cases(where: $caseWhere) {
					list {
						id
						proposals(where: $proposalWhere) {
							id
							policies {
								id
								issuerNumber
							}
						}
					}
				}
			}
		`
	},
	{
		type: "endorsementWhereInput",
		label: "Endorsement ID",
		componentName: "SelectByCaseId",
		query: gql`
			query fetchEndorsements(
				$caseWhere: caseWhere
				$proposalWhere: proposalWhere
			) {
				cases(where: $caseWhere) {
					list {
						id
						proposals(where: $proposalWhere) {
							id
							policies {
								id
								endorsements {
									id
								}
							}
						}
					}
				}
			}
		`
	},
	{
		type: "transactionWhereInput",
		label: "Transaction Number",
		componentName: "SelectById"
	}
	// {
	// 	type: "DateTimeOffset",
	// 	label: "Datetime",
	// 	componentName: "SelectByCaseId"
	// }
]
